import {Box, Grid} from '@material-ui/core'
import ButtonLarge from '../Buttons/ButtonLarge'
import Styled from '../Styled'
import H5 from '../Typography/H5'
import Subtitle1 from '../Typography/Subtitle1'
import styles from './styles'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import Caption from '../Typography/Caption'

export const Root = Styled(Box, styles.root)
export const Title = Styled(H5, styles.title)
export const AllFieldsMessage = Styled(Subtitle1, styles.allFieldsMessage)
export const ButtonsBox = Styled(Box, styles.buttonsBox)
export const ButtonSave = Styled(ButtonLarge, styles.buttonSave)
export const ButtonCancel = Styled(ButtonLarge, styles.buttonCancel)

export const BusyContent = Styled(Box, styles.busyContent)
export const BusyMessage = Styled(Subtitle1, styles.busyMessage)
export const BusyWarning = Styled(Caption, styles.busyWarning)

export const DialogRoot = Styled(Box, styles.dialogRoot)
export const SuccessCheckIcon = Styled(CheckCircleIcon, styles.successDialog.checkIcon)
export const SuccessButtonGrid = Styled(Grid, styles.successDialog.successButtonGrid)
